export default "__VITE_ASSET__BQU$Y$l5__"